// Utilities
import { createSimpleFunctional } from '@/util'

export const VListItemTitle = createSimpleFunctional('v-list-item-title')

export type VListItemTitle = InstanceType<typeof VListItemTitle>
